import { app } from 'apprun';
import { __ } from './Txlat';

import InquiryForm from './inquiry-form';

new InquiryForm({ message: __('I\'m looking for more information on a property.Please contact me.'), form_type: 'ContactUs' }).start('.elementor-form');
